// extracted by mini-css-extract-plugin
export default {"wrapper":"NotFound_wrapper__GQ00k","container":"NotFound_container__1fusd"};